import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { 
  PageLayout, 
  MainContent, 
  ContentContainer,
  PageTitle,
  PageSubtitle,
} from '../../styles/SharedStyles';
import ExpertSidebar from '../../components/expert/ExpertSidebar';
import styled from 'styled-components';
import { AppDispatch } from '../../store'
import {
  createStripeCheckoutSession,
} from '../../redux/slices/checkout/checkoutSlice';
import { finishStripeCheckout } from '../../redux/thunks/checkout';

function useQuery() {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
}

const CheckoutFinishedPage: React.FC = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const [updating, setUpdating] = useState(false);
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    // Handle Stripe checkout reuslts.
    let ignore = false;
    async function start() {
      try {
        const sessionId = query.get('stripe_session_id')
        const cancelled = query.get('cancelled')
        if (!sessionId || cancelled == 'true') {
          navigate('/expert/billing')
          return () => {ignore = true};
        }
        setUpdating(true)
        await dispatch(finishStripeCheckout({session_id: sessionId}))
      } catch(error) {
        console.log(error);
      }
      if (!ignore) {
        setUpdating(false)
        navigate('/expert/billing')
      }
    }
    start();
    return () => {ignore = true};
  }, [query, navigate])

  return (
    <PageLayout>
      <ExpertSidebar />
      <MainContent>
        <ContentContainer>
          <PageTitle variant="h4" fontWeight={600} gutterBottom>Checkout</PageTitle>
          <PageSubtitle>{updating ? 'processing...' : ''}</PageSubtitle>
        </ContentContainer>
      </MainContent>
    </PageLayout>
  );
};

export default CheckoutFinishedPage;
